import {CopyX} from "lucide-react";
import React from "react";
import "./SharedTopicWarning.scss";

export const SharedTopicWarningIcon = ({ intl, text, size = 16 }) => {
    const warningText = text || intl.formatMessage({
        id: 'bot.instructions.sharedTopic.warning',
        defaultMessage: 'This topic is shared across multiple modules. Changes to instructions will affect all modules using this topic.'
    });

    return (
        <span className="shared-topic-warning-icon" title={warningText}>
            <CopyX size={size} />
        </span>
    );
};

export const SharedTopicWarningText = ({ intl, text }) => {
    const warningText = text || intl.formatMessage({
        id: 'bot.instructions.sharedTopic.warning',
        defaultMessage: 'This topic is shared across multiple modules. Changes to instructions will affect all modules using this topic.'
    });

    return (
        <div className="shared-topic-warning-text">
            <CopyX size={16} />
            <span>{warningText}</span>
        </div>
    );
};
